// extracted by mini-css-extract-plugin
export default {"paddingBlock":"EditMtrForm_paddingBlock__SPfb6","buttons":"EditMtrForm_buttons__QakfU"};